import React from "react";
import { Column } from "primereact/column";
import { Row } from "primereact/row";
import type { FundingChartRow } from "../pages/FundingChart";
import InsuredTable from "app/uicomponents/macrocomponents/InteractiveProposal/Funding/InsuredTable";

type FundingRow = FundingChartRow;

const PRIMARY = "#1E3A8A";

const fmt = (v: number | null | undefined): string =>
  v == null
    ? "-"
    : new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(v);

interface FundingTableProps {
  data: FundingRow[];
  selectedYear: number;
  insuredName: string;
  isDark: boolean;
  cardBg: string;
  // divider: string;
  // textMain: string;
  textSub: string;
}

const FundingTable: React.FC<FundingTableProps> = ({
  data,
  selectedYear,
  insuredName,
  isDark,
  cardBg,
  // divider,
  // textMain,
  textSub,
}) => {
  const thBg = isDark ? "#3A3A50" : "#EBEBEF";

  const columns: any[] = [
    {
      field: "planYear",
      header: "Plan Year",
      formatter: (_: any, __: any, row: FundingRow) => (
        <span className={row.year === selectedYear ? "font-bold" : ""}>{row.planYear}</span>
      ),
    },
    {
      field: "year",
      header: "Year",
      formatter: (_: any, __: any, row: FundingRow) => (
        <span className={row.year === selectedYear ? "font-bold" : ""}>{row.year}</span>
      ),
    },
    { field: "clientPremium", header: "Client Premium", formatter: (v: number) => fmt(v) },
    { field: "clientPlanFee", header: "Plan Fees", formatter: (v: number) => fmt(v) },
    {
      field: "clientInterestPayment",
      header: "Interest Payment",
      formatter: (v: number) => fmt(v),
    },
    {
      field: "clientOriginationFees",
      header: "Origination Fees",
      formatter: (v: number) => fmt(v),
    },
    { field: "lenderPremium", header: "Financed Premium", formatter: (v: number) => fmt(v) },
    { field: "lenderOriginationFees", header: "Financing Fees", formatter: (v: number) => fmt(v) },
    {
      field: "totalPolicyPremium",
      header: "Total Policy Premium",
      formatter: (v: number) => <span className="font-bold">{fmt(v)}</span>,
    },
  ];

  const columnGroupRow = (
    <Row>
      <Column header="" colSpan={2} style={{ background: thBg }} align="center" />
      <Column header="Client Payments" colSpan={4} style={{ background: thBg }} align="center" />
      <Column header="Financed Payments" colSpan={2} style={{ background: thBg }} align="center" />
      <Column
        header="Total Premium Paid to Insurance Company"
        colSpan={1}
        style={{ background: thBg }}
        align="center"
      />
    </Row>
  );

  return (
    <div className={`rounded-2xl shadow-md overflow-hidden ${cardBg}`}>
      <InsuredTable
        data={data}
        columns={columns}
        hoverColor={PRIMARY}
        columnGroup={columnGroupRow}
        scrollable
        scrollHeight="500px"
      />

      <p className={`text-[11px] text-center py-2 ${textSub}`}>Plan Funding for {insuredName}</p>
    </div>
  );
};

export default FundingTable;
